//list of client side and server side http user friendly error messages
export const HttpErrorStatusCodes = [
    {
        statusCode: 401,
        description: "UNAUTHORIZED",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 403,
        description: "FORBIDDEN",
        message: "You don't have enough permission to access this functionality. Try later or contact support",
    },
    {
        statusCode: 404,
        description: "NOT_FOUND",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 405,
        description: "FORBIDDEN",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 406,
        description: "NOT_ACCEPTABLE",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 407,
        description: "PROXY_AUTHENTICATION_REQUIRED",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 408,
        description: "REQUEST_TIMEOUT",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 410,
        description: "GONE",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 411,
        description: "LENGTH_REQUIRED",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 412,
        description: "PRECONDITION_FAILED",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 413,
        description: "PAYLOAD_TOO_LONG",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 414,
        description: "URI_TOO_LONG",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 415,
        description: "UNSUPPORTED_MEDIA_TYPE",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 416,
        description: "RANGE_NOT_SATISFIABLE",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 417,
        description: "EXPECTATION_FAILED",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 418,
        description: "IM_A_TEAPOT",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 422,
        description: "UNPROCESSABLE_ENTITY",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 426,
        description: "UPGRADE_REQUIRED",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 429,
        description: "TOO_MANY_REQUESTS",
        message: "Something went wrong. Try later or contact support",
    },
    {
       statusCode: 431,
       description: "REQUEST_HEADER_FIELDS_TOO_LARGE",
       message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 500,
        description: "INTERNAL_SERVER_ERROR",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 501,
        description: "NOT_IMPLEMENTED",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 502,
        description: "BAD_GATEWAY",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 503,
        description: "SERVICE_UNAVAILABLE",
        message: "Something went wrong.. Please try again",
    },
    {
        statusCode: 504,
        description: "GATEWAY_TIMEOUT",
        message: "Something went wrong.. Please try again",
    },
    {
        statusCode: 505,
        description: "HTTP_VERSION_NOT_SUPPORTED",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 506,
        description: "VARIANT_ALSO_NEGOTIATES",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 507,
        description: "INSUFFICIENT_STORAGE",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 508,
        description: "LOOP_DETECTED",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 510,
        description: "NOT_EXTENDED",
        message: "Something went wrong. Try later or contact support",
    },
    {
        statusCode: 511,
        description: "NETWORK_AUTHENTICATION_REQUIRED",
        message: "Something went wrong. Try later or contact support",
    },
];